import { graphql } from 'app/generated/gql'

export const LIST_MEMBERS_QUERY = graphql(`
  query ListMembers($listId: ID!, $stageId: ID, $search: String, $pagination: PaginationInput, $sort: SortInput) {
    listMembers(listId: $listId, stageId: $stageId, search: $search, pagination: $pagination, sort: $sort) {
      members {
        type
        entityId
        stageId
      }
      total
      page
    }
  }
`)

export const LIST_STAGE_COUNTS_QUERY = graphql(`
  query ListStageCounts($listId: ID!, $search: String) {
    listStageCounts(listId: $listId, search: $search) {
      stageId
      count
    }
  }
`)

export const CREATE_LIST_ITEM_MUTATION = graphql(`
  mutation CreateListItem($input: CreateListItemInput!) {
    createListItem(input: $input) {
      id
      orgId
      workspaceId
      locationId
      listId
      entityId
      stageId
      version
      createdDate
      updatedDate
    }
  }
`)

export const UPDATE_LIST_ITEM_MUTATION = graphql(`
  mutation UpdateListItem($id: ID!, $input: UpdateListItemInput!) {
    updateListItem(id: $id, input: $input) {
      id
      orgId
      workspaceId
      locationId
      listId
      entityId
      stageId
      version
      createdDate
      updatedDate
    }
  }
`)

export const DELETE_LIST_ITEM_MUTATION = graphql(`
  mutation DeleteListItem($id: ID!) {
    deleteListItem(id: $id)
  }
`)

export const LIST_ITEMS_QUERY = graphql(`
  query ListItems($search: String, $pagination: PaginationInput) {
    listItems(search: $search, pagination: $pagination) {
      hits {
        id
        orgId
        workspaceId
        locationId
        listId
        entityId
        stageId
        version
        createdDate
        updatedDate
      }
      total
      page
    }
  }
`)

export const SIDEBAR_LISTS_QUERY = graphql(`
  query SidebarLists {
    lists(pagination: { limit: 500 }) {
      id
      entityType
      system
      filters {
        attribute
        secondaryAttribute
        displayName
        operator
        value
        secondaryValue
        static
        uniqOperator
        readOnly
        nonEmpty
        useAsterisk
        group
        subQuery
        type
        defaultValue
        dateOperator
        includeToday
        includeYesterday
        includeWeeks
        limitToMonth
        includeInThePast
        options
      }
      join
    }
  }
`)

export const SYSTEM_LIST_QUERY = graphql(`
  query SystemList($id: ID!) {
    list(id: $id) {
      id
      orgId
      workspaceId
      name
      entityType
      stages {
        id
        name
        color
        system
      }
      defaultStageId
      filters {
        attribute
        secondaryAttribute
        displayName
        operator
        value
        secondaryValue
        static
        uniqOperator
        readOnly
        nonEmpty
        useAsterisk
        group
        subQuery
        type
        defaultValue
        dateOperator
        includeToday
        includeYesterday
        includeWeeks
        limitToMonth
        includeInThePast
        options
      }
      join
      system
      version
      createdDate
      updatedDate
    }
  }
`)
